"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const snap_ui_1 = require("@teamsnap/snap-ui");
const React = __importStar(require("react"));
const SubscriptionBenefits = ({ benefits }) => {
    return (React.createElement("section", null,
        React.createElement("ul", { className: "sui-mb-2" }, benefits.map((benefit, index) => (React.createElement("li", { className: "sui-flex sui-items-center sui-mb-2", key: index },
            React.createElement(snap_ui_1.Icon, { name: "check", className: "sui-text-blue-40 sui-mr-2" }),
            React.createElement("span", { className: "sui-font-bold" }, benefit)))))));
};
exports.default = SubscriptionBenefits;
